import { SupportedBarcode } from '@any2any/platform-api';
import { ScannerQRCodeConfig, ScannerQRCodeDevice, ScannerQRCodeResult } from 'ngx-scanner-qrcode';

export namespace QrcodeScanner {

  export type Status = 'initialization' | 'ready' | 'no_permissions' | 'no_cameras' | 'paused' | 'scanning'

  export type Config = ScannerQRCodeConfig;

  export type Device = ScannerQRCodeDevice;

  export type Result = ScannerQRCodeResult;

  export type CameraSelector = (cameras: QrcodeScanner.Device[]) => QrcodeScanner.Device;

  export interface Data {
    readonly data: string;
  }

  export interface DataFromWidget extends Data {
    readonly supported: SupportedBarcode[];
    readonly widgetId: string;
  }

  export interface FancySvgCorner {
    rotate: string;
    position: object;
    ngClass: object;
  }

  export const FANCY_SVG_CORNERS: FancySvgCorner[] = [
    { rotate: '0deg', position: { top: 0, left: 0 } },
    { rotate: '90deg', position: { top: 0, right: 0 } },
    { rotate: '180deg', position: { bottom: 0, right: 0 } },
    { rotate: '270deg', position: { bottom: 0, left: 0 } },
  ]
    .map(cornerInit => {
      const ngClass = Object.keys(cornerInit.position)
        .map(side => `push-${side}`)
        .reduce((obj: object, klass: string) => ({ ...obj, [klass]: true }), {});
      return {
        ...cornerInit,
        ngClass
      };
    });

}
